import { useMutation } from '@tanstack/react-query';
import FooterService from '../layouts/Footer/footerServices/FooterServices';

// Footer üçün mutation hooks
export const useSubscribe = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await FooterService.Subscribe(email);
      return response;
    },
    retry: 1,
  });
};


